import {
  List,
  Divider,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import QuestionMarkRoundedIcon from "@mui/icons-material/QuestionMarkRounded";
import { FaTwitter, FaDiscord } from "react-icons/fa";

import GAMES from "../../games";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageModal from "../LanguageModal";
import { useState } from "react";

export default function NavLists({ open, setOpen }) {
  const { i18n, t } = useTranslation();

  const [isChangingLanguage, setIsChangingLanguage] = useState(false);

  function handleLinkClick() {
    if (setOpen) {
      setOpen(false);
    }
  }

  return (
    <>
      <LanguageModal
        open={isChangingLanguage}
        onClose={() => setIsChangingLanguage(false)}
      />
      <List>
        <NavListItem
          open={open}
          icon={<img src={`/img/lang/${i18n.language}.svg`} width={24} />}
          text={`${i18n.language.toUpperCase()} (${t("Language")})`}
          onClick={() => setIsChangingLanguage(true)}
        />
        <NavListItem
          open={open}
          icon={<HomeRoundedIcon />}
          text={t("Home")}
          to="/"
          onClick={handleLinkClick}
        />
      </List>
      <Divider />
      <List>
        {Object.values(GAMES).map((game) => (
          <NavListItem
            key={game.modulo}
            open={open}
            icon={<img src={game.iconUrl} width={24} />}
            text={t(game.name)}
            to={game.url}
            onClick={handleLinkClick}
          />
        ))}
      </List>
      <Divider />
      <List>
        <NavListItem
          open={open}
          icon={<QuestionMarkRoundedIcon />}
          text={t("FAQ")}
          to="/faq"
          onClick={handleLinkClick}
        />
        <NavListItem
          open={open}
          icon={<FaTwitter size={24} />}
          text="Twitter"
          href="https://twitter.com/nice2winDapp"
          onClick={handleLinkClick}
        />
        <NavListItem
          open={open}
          icon={<FaDiscord size={24} />}
          text="Discord"
          href="https://discord.gg/r97TVvmgng"
          onClick={handleLinkClick}
        />
      </List>
    </>
  );
}

function NavListItem({ open, icon, text, to, href, onClick }) {
  const location = useLocation();
  const isDesktop = typeof open === "boolean";
  return (
    <ListItem disablePadding sx={isDesktop ? { display: "block" } : undefined}>
      <ListItemButton
        component={to && Link}
        to={to}
        href={href}
        selected={location.pathname === to}
        {...(href ? { target: "_blank", rel: "noreferrer" } : {})}
        onClick={onClick && onClick}
        sx={
          isDesktop
            ? {
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }
            : undefined
        }
      >
        <ListItemIcon
          sx={
            isDesktop
              ? {
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                }
              : undefined
          }
        >
          {icon}
        </ListItemIcon>
        <ListItemText
          primary={text}
          sx={isDesktop ? { opacity: open ? 1 : 0 } : undefined}
        />
      </ListItemButton>
    </ListItem>
  );
}
